// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nlhl","left":"styles_left__2nKxS"};